import cx from 'clsx';
import React, { forwardRef, Fragment } from 'react';
import styles from './Input.module.scss';
import typographyStyles from 'styles/global/typography.module.scss';
import utilityStyles from 'styles/global/utility.module.scss';

interface OwnProps {
  variant?: 'standard' | 'ghost';
  size?: 'regular' | 'small';
  error?: string;
}

type InputProps = Omit<JSX.IntrinsicElements['input'], 'size'> & OwnProps;

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { className, variant = 'standard', error, size = 'regular', ...rest } = props;

  const inputClassName = cx({
    [utilityStyles.resetInput]: true,
    [typographyStyles.new_ibm_regular_16]: size === 'small',
    [styles.input]: true,
    [styles[variant]]: true,
    [styles[size]]: true,
    [styles.error]: !!error,
    ...(className && { [className]: true }),
  });

  return (
    <Fragment>
      <input className={inputClassName} {...rest} ref={ref} />
    </Fragment>
  );
});

export default Input;
